import {useCallback, useMemo} from 'react'

import {CommentsSection} from '../components'
import {RIA_COMMENTS_PAGE_SIZE} from '../consts'
import {useAddRiaComment, useRiaComments} from '../hooks'

type RiaCommentsContainerProps = {
  riaId: string
  canManage: boolean
}

export const RiaCommentsContainer = ({riaId, canManage}: RiaCommentsContainerProps) => {
  const {data, fetchNextPage, hasNextPage, isFetchingNextPage} = useRiaComments({
    riaId,
    pageSize: RIA_COMMENTS_PAGE_SIZE
  })
  const {mutateAsync: addComment, isPending} = useAddRiaComment()

  const comments = useMemo(() => data?.pages.flatMap((p) => p.items) ?? [], [data?.pages])

  const handleLoadMore = useCallback(() => {
    void fetchNextPage()
  }, [fetchNextPage])

  const handleAddComment = useCallback(
    async (commentText: string) => {
      await addComment({riaId, data: {commentText}})
    },
    [riaId, addComment]
  )

  return (
    <CommentsSection
      comments={comments}
      canManage={canManage}
      onAddComment={handleAddComment}
      isSubmitting={isPending}
      canLoadMore={!!hasNextPage}
      isLoadingMore={isFetchingNextPage}
      onLoadMore={handleLoadMore}
    />
  )
}
